<!-- Creata solo per testare le tipologie di domande -->
<template>
  <div class="pa-8">
    <h1><b>Esempi per le diverse tipologie di domande</b></h1>
    <br>
    <v-row>
      <v-col>
        <!-- :risposteCorrette="risposteCorrette" -->
        <domande-risposte-component
          ref="domandeRisposteComponentRef"
          :domandeConRisposte="domandeConRisposte"
          stato="started"
          @aggiorna-risposte-utente="aggiornaRisposteUtente"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn color="primary" @click="inviaRisposte">
          Invia Risposte
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import mixin from '../../mixins';
import DomandeRisposteComponent from './DomandeRisposteComponent.vue';

export default {
  name: 'PadreDomandeRisposte',
  components: {
    DomandeRisposteComponent
  },
  data() {
    return {
      domandeConRisposte: [], // Lista di domande di esempio (inizializzata nel mounted)
      // risposteCorrette: {}, // Gestite dentro il componente figlio

      // Qui si raccolgono le risposte inserite (il componente figlio le passa tramite evento)
      risposteUtente: {}
    }
  },
  mounted() {
    this.domandeConRisposte = [
        {
          tipo: "select",
          domanda: "Scegli, estremi inclusi ma senza segno, dal primo (1°) al terzo (3°) carattere, del codice identificativo del richiedente $codice_identificativo_az (AB)",
          risposte: ["AB", "ABC", "DSA", "ASD"],
          schermata: 1
        },
        {
          tipo: "reverse",
          domanda: "Scrivere al contrario le consonanti presenti all'interno di 'Bando'",
          risposte: ["dnB"],
          schermata: 1
        },
        {
          tipo: "monochar",
          domanda: "inserire caratteri monochar",
          risposte: ["ABCDEF"],
          schermata: 1
        },
        {
          tipo: "radio3",
          domanda: "Selezionare https://www.inail.it l'indirizzo del sito dell'INAIL senza .it ma con tutti gli altri caratteri:",
          risposte: ["https://www.inail", "hhttps://www.inail", "htps://www.inail.it", "http://www.inail", "https.//www.inail", "https://www,inail", "https://www.ianil", "https://www.inali", "https.//www.inail.it", "https://www.inail.it", "https://www,inail.it"],
          schermata: 1
        },
        {
          tipo: "select",
          domanda: "Mettere il giorno della data (18) scrivendolo in lettere",
          risposte: ["18", "45484", "mercoledì", "venerdì", "oggi"],
          schermata: 1
        },
        {
          tipo: "checkbox",
          domanda: "Confermo di aver compilato i campi in questa pagina con le informazioni corrette",
          risposte: [true],
          schermata: 1
        },
        // {
        //   tipo: "checkbox_bloccante",
        //   domanda: "Spunto questa casella per confermare la mia umanità",
        //   risposte: [true],
        //   schermata: 1
        // },
        {
          tipo: "summary",
          domanda: "Riepilogo",
          risposte: [true],
          schermata: 2
        }
    ];
    // Dentro il componente genero anche un UID
  },
  methods: {
    aggiornaRisposteUtente(nuoveRisposte) {
      this.risposteUtente = nuoveRisposte;
    },

    // Funzione di esempio per "inviare" le risposte
    inviaRisposte() {
      // Chiamo la funzione del component figlio che controlla la corretteza delle risposte date dall'utente:
      if (this.$refs.domandeRisposteComponentRef && typeof this.$refs.domandeRisposteComponentRef.controllaRisposte === 'function') {
        if(!this.$refs.domandeRisposteComponentRef.controllaRisposte()){
          console.log("Risposte fornite non valide!!");
          return;
        }
      }
      console.log("Risposte corrette");
      console.log('Invio risposte utente:', this.risposteUtente);
    }
  }
}
</script>
